// ScrollToTopButton.js
import React, { useState, useEffect } from 'react';
import Fab  from '@mui/material/Fab';
import KeyboardDoubleArrowUpRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowUpRounded';
import Typography from '@mui/material/Typography'
import {Wrapper} from './ScrolTopButtonStyled'

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show the button when the user scrolls down
  const handleScroll = () => {
    const scrollY = window.scrollY;
    if (scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to the top when the button is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Wrapper>
    <Fab 
      variant="outlined"
      onClick={scrollToTop}
      className='scrollButton'
      style={{
        opacity: isVisible ? 1 : 0,
      }}
    >
      <KeyboardDoubleArrowUpRoundedIcon  color="primary"/>
     
    </Fab >
    <Typography
        variant="body2"
        className='scollText'
        style={{
          opacity: isVisible ? 1 : 0,
        }}
      >
        Go to Top
      </Typography>
    </Wrapper>
  );
};

export default ScrollToTopButton;
